import * as Yup from "yup";

export function initialValues(week, cantWeeks) {
  return {
    title: week?.title || "",
    index: week?.index || 0,
    syllabuSubjectGradeId: week?.syllabuSubjectGradeId || "",
  };
}

export function validationSchema() {
  return Yup.object({
    title: Yup.string().required("El título de la unidad es obligatorio"),
  });
}
